export default __webpack_public_path__ + "static/demo_keberkesanan_sabun_champaca_7-39b08b1a8585f5d9eef4ef3611c5c822.mp4";